var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1499_9975)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.82847V15.0348C4 15.8063 4.61561 16.4316 5.375 16.4316H14.625C15.3844 16.4316 16 15.8063 16 15.0348V4.10727C16 3.73415 15.8531 3.37654 15.5919 3.11416L13.3239 0.835347C13.0665 0.576706 12.7191 0.431641 12.357 0.431641H5.375C4.61561 0.431641 4 1.05702 4 1.82847ZM4.875 15.0348V1.82847C4.875 1.54794 5.09886 1.32053 5.375 1.32053H12.1875V4.36815C12.1875 4.89413 12.6072 5.32053 13.125 5.32053H15.125V15.0348C15.125 15.3153 14.9011 15.5428 14.625 15.5428H5.375C5.09886 15.5428 4.875 15.3153 4.875 15.0348ZM15.125 4.43164V4.10727C15.125 3.97159 15.0716 3.84155 14.9766 3.74614L13.0625 1.82291V4.36815C13.0625 4.40321 13.0905 4.43164 13.125 4.43164H15.125Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4316C12 12.4316 13 11.4316 13 9.43164H11V7.43164H10V9.43164V12.4316Z",
    fill: "#E48762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.43164V6.43164C12.75 6.43164 14 7.68164 14 8.43164H12Z",
    fill: "#F9D4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.05664C0 4.64243 0.335786 4.30664 0.75 4.30664H8.25C8.66421 4.30664 9 4.64243 9 5.05664V12.5566C9 12.9709 8.66421 13.3066 8.25 13.3066H0.75C0.335786 13.3066 0 12.9709 0 12.5566V5.05664Z",
    fill: "#C25B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.1924V6.18164H4.33301C4.82975 6.18164 5.15446 6.20557 5.30713 6.25342C5.55094 6.33089 5.75146 6.49609 5.90869 6.74902C6.0682 7.00195 6.14795 7.3278 6.14795 7.72656C6.14795 8.08887 6.07959 8.39307 5.94287 8.63916C5.80615 8.88298 5.63525 9.05501 5.43018 9.15527C5.2251 9.25326 4.87191 9.30225 4.37061 9.30225H3.82715V11.1924H3ZM3.82715 7.0293V8.45117H4.28516C4.59277 8.45117 4.80127 8.42952 4.91064 8.38623C5.0223 8.34294 5.11344 8.26546 5.18408 8.15381C5.25472 8.03988 5.29004 7.90088 5.29004 7.73682C5.29004 7.57048 5.25358 7.43034 5.18066 7.31641C5.10775 7.20247 5.01774 7.12614 4.91064 7.0874C4.80355 7.04867 4.57682 7.0293 4.23047 7.0293H3.82715Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1499_9975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.431641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.0b49f0e159ea83a2968fa3079b91099e.svg";
export { ForwardRef as ReactComponent };